export const CREATE_STATEMENT_TEMPLATE_SUCCESS = 'CREATE_STATEMENT_TEMPLATE_SUCCESS';

export const createStatementTemplateSuccess = (statementTemplate) => ({
    type: CREATE_STATEMENT_TEMPLATE_SUCCESS,
    payload: {
        statementTemplate,
    }
});
